import { useState } from 'react';
import { useInstallPrompt } from '../../hooks/useInstallPrompt.js';

export function InstallPrompt() {
  const install = useInstallPrompt();
  const [showIosHelp, setShowIosHelp] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (install.isInstalled || dismissed) return null;
  if (!install.canInstall && !install.isIos) return null;

  return (
    <div className="install-prompt term-panel" role="complementary" aria-label="התקנת אפליקציה">
      {!showIosHelp ? (
        <>
          <span className="term-text mono">התקן את האפליקציה למסך הבית — חוויה מלאה והתראות על משימות חדשות</span>
          <div className="install-prompt__actions">
            {install.canInstall ? (
              <button type="button" className="btn btn--primary btn--sm" onClick={() => void install.promptInstall()}>
                התקן את האפליקציה
              </button>
            ) : (
              <button type="button" className="btn btn--primary btn--sm" onClick={() => setShowIosHelp(true)}>
                איך מתקינים?
              </button>
            )}
            <button type="button" className="btn btn--ghost btn--sm" onClick={() => setDismissed(true)}>
              סגור
            </button>
          </div>
        </>
      ) : (
        <div className="term-text mono" style={{ lineHeight: 1.7 }}>
          לחצו על כפתור השיתוף <span aria-hidden="true">⬆️</span> בסרגל הכלים של Safari, ואז &quot;הוסף
          למסך הבית&quot;.
          <div>
            <button type="button" className="btn btn--ghost btn--sm" onClick={() => setDismissed(true)}>
              הבנתי
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
